import { AbstractControl, ValidatorFn } from '@angular/forms'

export function isValidCPT(code: string) {
  return (
    typeof code === 'string' &&
    code.length === 5 &&
    /^[a-zA-Z0-9]\d\d\d[a-zA-Z0-9]$/.test(code)
  )
}

export function standardizeProcedureCode(
  code: string,
): [string | undefined, string | undefined] {
  let standardizedCode = code.toUpperCase()
  let modifier = ''

  // if the first five characters are numbers, then assume it is a CPT code
  if (/^[A-Z0-9]\d\d\d[A-Z0-9]$/.test(standardizedCode.substr(0, 5))) {
    standardizedCode = standardizedCode.substr(0, 5)
    modifier = code.toUpperCase().substr(5)
  }

  // if we have an invalid CPT/HCPCS code, return nothing
  if (!isValidCPT(standardizedCode)) {
    return [undefined, undefined]
  }

  // transform commonly misused modifiers
  switch (modifier) {
    case 'LEFT':
      modifier = 'LT'
      break
    case 'RIGHT':
      modifier = 'RT'
      break
    case 'LTRT':
      modifier = '50'
      break // bilateral modifier 50
    case 'RTLT':
      modifier = '50'
      break // bilateral modifier 50
  }

  // get rid of completely invalid modifiers
  if (modifier.length !== 2) {
    modifier = ''
  }

  return [standardizedCode, modifier.length > 0 ? modifier : undefined]
}

export const procedureCodeValidator: ValidatorFn = (
  control: AbstractControl,
): { [key: string]: any } | null => {
  if (Array.isArray(control.value)) {
    return control.value.every((code) => isValidCPT(code)) ? null : { procedureCode: { value: control.value } }
  }

  const valid = isValidCPT(control.value)
  return valid ? null : { procedureCode: { value: control.value } }
}
